import dateFnsFormat from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import dateFnsIsValid from 'date-fns/isValid';
import locale from 'date-fns/locale/pt-BR';
import dateFnsParse from 'date-fns/parse';
import startOfDay from 'date-fns/startOfDay';

export function dateParse(value: any, format: string = null): Date {
  if (!value) return value;
  if (value instanceof Date) return value;

  const date = !format ? new Date(value) : dateFnsParse(value, format, new Date(), { locale });
  if (!dateFnsIsValid(date)) return value;

  return date;
}

export function dateFormat(date: Date | string, format: string = 'dd/MM/yyyy'): string {
  if (!date) {
    return '-';
  }

  if (typeof date === 'string') {
    return dateFnsFormat(dateParse(date), format, { locale });
  }

  return dateFnsFormat(date, format, { locale });
}

/** Maps common Moment-style tokens (DD, YYYY) to date-fns v2 tokens. */
function momentLikePatternToDateFns(pattern: string): string {
  return pattern.replace(/YYYY/g, 'yyyy').replace(/DD/g, 'dd');
}

export function dateMomentFormat(date: string | Date | null | undefined, formatStr: string = 'dd/MM/yyyy') {
  if (date == null || date === '') {
    return '-';
  }

  const asDate = typeof date === 'string' ? dateParse(date) : date;

  if (!(asDate instanceof Date) || !dateFnsIsValid(asDate)) {
    return '-';
  }

  return dateFnsFormat(asDate, momentLikePatternToDateFns(formatStr), { locale });
}

export function isDateExpired(date: string) {
  const parsed = dateFnsParse(date, 'yyyy-MM-dd', new Date());

  if (!dateFnsIsValid(parsed)) {
    return false;
  }

  const dateToExpire = startOfDay(parsed);
  const now = new Date();

  return isAfter(now, dateToExpire);
}

export function parseDdMmYyyy(value: string): Date {
  return dateFnsParse(value.trim(), 'dd/MM/yyyy', new Date(), { locale });
}
